import z from 'zod';
import {firestoreTimestampToDateSchema} from '../_other/firestore';
import {userDbSchema} from './userDbSchema';

/**
 * Output schema for user objects.
 * Adds the document id on top of the Firestore shape.
 */
export const userSchema = userDbSchema.omit({createdAt: true, lastLogin: true}).extend({
  id: z.string(),
  createdAt: firestoreTimestampToDateSchema,
  lastLogin: firestoreTimestampToDateSchema,
});

export type User = z.infer<typeof userSchema>;
